'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.concat')
require('core-js/modules/es.array.find')
require('core-js/modules/es.array.find-index')
require('core-js/modules/es.array.index-of')
require('core-js/modules/es.array.slice')
require('core-js/modules/es.array.splice')
exports.__esModule = true
exports.castArr = castArr
exports.toggleIncluding = toggleIncluding
exports.resetArr = resetArr
exports.findById = findById
exports.findIndById = findIndById
exports.findByIdAndType = findByIdAndType
exports.findByIdAndDel = findByIdAndDel
exports.pushIfNotExist = pushIfNotExist
exports.Finder = void 0

var _is = require('../is')

var _Finder = _interopRequireDefault(require('./Finder'))
exports.Finder = _Finder.default

/**
 * @namespace __Array
 */

/**
 * Возвращает переданный аргумент, если он является массивом, иначе новый пустой массив
 *
 *
 * @param {?Array<*>} maybeArr
 * @example
 * castArr( [ 1, 2, 3 ] ) // [ 1, 2, 3 ]
 * castArr( { x: [ 1, 2, 3 ] } ) // []
 * @returns {Array<*>}
 * @memberof __Array
 */
function castArr(maybeArr) {
  if ((0, _is.isArr)(maybeArr)) {
    return maybeArr
  }

  return []
}

/**
 * Возвращает новый массив и исключает из него элемент,
 * если он присутствует, либо добавляет, если его там нет
 *
 *
 * @param {Array<T>} array
 * @param {T} item
 * @example
 * toggleIncluding( [ 1, 2, 3 ], 2 ) // [ 1, 3 ]
 * toggleIncluding( [ 1, 2, 3 ], 5 ) // [ 1, 2, 3, 5 ]
 * @returns {Array<T>}
 * @memberof __Array
 */
function toggleIncluding(array, item) {
  var arr = array.slice(0)
  var ind = arr.indexOf(item)
  if (ind !== -1) {
    arr.splice(ind, 1)
  } else {
    arr.push(item)
  }
  return arr
}

/**
 * Заменяет элементы массива если они переданы вторым аргументом,
 * иначе очищает массив
 *
 *
 * @param {Array<T>} arr
 * @param {Array<T>} [newVals]
 * @memberof __Array
 */
function resetArr(arr, newVals) {
  arr.splice.apply(arr, [0, arr.length].concat(castArr(newVals)))
}

/**
 * Поиск индекса элемента в массиве по id
 *
 *
 * @param {Array<T>} arr
 * @param {string} id
 * @returns {(T | null)}
 * @memberof __Array
 */
function findById(arr, id) {
  var item = arr.find(function(it) {
    return it.id === id
  })
  return (0, _is.isUndef)(item) ? null : item
}

/**
 * Поиск индекса элемента в массиве по id
 *
 *
 * @param {Array<T>} arr
 * @param {string} id
 * @returns {number}
 * @memberof __Array
 */
function findIndById(arr, id) {
  return arr.findIndex(function(it) {
    return it.id === id
  })
}

/**
 * Поиск элемента в массиве по id и type
 * @deprecated
 *
 * @param {Array<T>} arr
 * @param {HasIdTypeItemType} params
 * @returns {(T | null)}
 * @memberof __Array
 */
function findByIdAndType(arr, params) {
  var id = params.id,
    type = params.type
  var item = arr.find(function(it) {
    return it.id === id && it.type === type
  })
  return (0, _is.isUndef)(item) ? null : item
}

/**
 * Удаляет элемент из массива, если он там существует
 * (поиск осуществляется по id)
 *
 *
 * @param {Array<T>} arr
 * @param {string} id
 * @returns {boolean}
 * @memberof __Array
 */
function findByIdAndDel(arr, id) {
  var ind = findIndById(arr, id)
  if (ind !== -1) {
    arr.splice(ind, 1)
    return true
  }
  return false
}

/**
 * Добавляет элемент в массив, если его там не существует
 * (поиск осуществляется по id)
 *
 *
 * @param {Array<T>} arr
 * @param {T} item
 * @returns {boolean}
 * @memberof __Array
 */
function pushIfNotExist(arr, item) {
  var hasItem = findIndById(arr, item.id) !== -1
  if (!hasItem) {
    arr.push(item)
    return true
  }
  return false
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/arr/index.js
// module id = 166
// module chunks = 0